import { Bell, BellRing } from 'lucide-react';
import { useTableSubscription, useSubscribeTable, useUnsubscribeTable } from '../api/notifications';

type Props = {
  tableId: string;
};

export default function SubscribeButton({ tableId }: Props) {
  const { data, isLoading } = useTableSubscription(tableId);
  const subscribe = useSubscribeTable(tableId);
  const unsubscribe = useUnsubscribeTable(tableId);

  const subscribed = data?.subscribed ?? false;
  const isPending = subscribe.isPending || unsubscribe.isPending;

  if (isLoading) return null;

  const handleToggle = () => {
    if (subscribed) {
      unsubscribe.mutate();
    } else {
      subscribe.mutate();
    }
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      disabled={isPending}
      className={`flex items-center gap-2 px-3 py-1.5 text-xs font-medium rounded-lg border transition disabled:opacity-50 ${
        subscribed
          ? 'border-primary/40 bg-primary/5 text-primary'
          : 'border-pale-grey-three text-slate hover:border-primary/40 hover:bg-primary/5 hover:text-primary'
      }`}
    >
      {subscribed ? <BellRing className="w-3.5 h-3.5" /> : <Bell className="w-3.5 h-3.5" />}
      {subscribed ? 'Suscrito' : 'Suscribirme a nuevos datos'}
    </button>
  );
}
